<template>
  <div>
    <div class="card">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3" v-if="modeReglement.id">
              {{ $t('addModeReglement.titleEdit') }}
            </h1>
            <h1 class="title is-size-3" v-else>
              {{ $t('addModeReglement.titleAdd') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'addModeReglement.error.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="columns is-multiline">
          <b-field :label="$t('addModeReglement.informationModeReglement.libelle')"
                   class="obligatoire column is-6">
            <b-input v-model="modeReglement.libelle"></b-input>
          </b-field>
          <b-field :label="$t('addModeReglement.informationModeReglement.actionAchat')"
                   class="column is-6">
            <b-select v-model="modeReglement.actionAchat" expanded>
              <option v-for="actionAchat in listeActionAchat"
                      :value="actionAchat.code"
                      :key="actionAchat.code">
                {{ $t(actionAchat.libelle) }}
              </option>
            </b-select>
          </b-field>
          <b-checkbox v-model="modeReglement.aEffet" class="column is-2">
            <p class="is-default">
              {{ $t('addModeReglement.informationModeReglement.aEffet')}}
            </p>
          </b-checkbox>
          <b-checkbox v-model="modeReglement.centralisationCompteBanque" class="column is-3">
            <p class="is-default">
              {{ $t('addModeReglement.informationModeReglement.centralisationCompteBanque')}}
            </p>
          </b-checkbox>
          <b-checkbox v-model="modeReglement.ribObligatoire" class="column is-2">
            <p class="is-default">
              {{ $t('addModeReglement.informationModeReglement.ribObligatoire')}}
            </p>
          </b-checkbox>
          <b-checkbox v-model="modeReglement.traite" class="column is-2">
            <p class="is-default">
              {{ $t('addModeReglement.informationModeReglement.traite')}}
            </p>
          </b-checkbox>
          <b-checkbox v-model="modeReglement.prelevement" class="column is-2">
            <p class="is-default">
              {{ $t('addModeReglement.informationModeReglement.prelevement')}}
            </p>
          </b-checkbox>
          <b-field :label="$t('addModeReglement.informationModeReglement.codeExterneFactor')"
                   class="column is-6">
            <b-input v-model="modeReglement.codeExterneFactor"></b-input>
          </b-field>
          <b-field :label="$t('addModeReglement.informationModeReglement.codeExterneComptabilite')"
                   class="column is-6">
            <b-input v-model="modeReglement.codeExterneComptabilite"></b-input>
          </b-field>
        </div>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('addModeReglement.actions.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="saveModeReglement()">
                {{ $t('general.button.sauvegarder') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { create, update } from '@/api/modeReglement/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import validation from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { LISTE_ACTION_ACHAT } from '@/configuration/parametrage/modeReglementConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    modeReglement: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      listeActionAchat: LISTE_ACTION_ACHAT,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    async saveModeReglement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        if (this.modeReglement.id) {
          await update(this.modeReglement);
          messageSuccess(this.$i18n.t('addModeReglement.success.edit'));
        } else {
          await create(this.modeReglement);
          messageSuccess(this.$i18n.t('addModeReglement.success.add'));
        }
        await this.loadParametreForce(typesParametres.PARAMETRES_KEYS.modeReglement);
        loadingComponent.close();
        this.$emit('reloadModeReglement');
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
};

</script>
